export abstract class Mapper<T, DTO> {

  /**
   * Map dto values to entity.
   *
   * @param dto
   */
  abstract mapToEntity(dto: DTO): T;

  /**
   *
   * @param dtos
   *
   * @returns
   */
  mapToEntities(dtos: DTO[]): T[] {
    return dtos.map((dto) => this.mapToEntity(dto));
  }
}
